import React, { useRef } from 'react';
import RadioButton from '../inputs/RadioButton';
import Image from '../image/Image';

import './RadioListItem.css';

interface RadioListItemProps {
  id: string | null;
  formik: any;
  value: string;
  name: string;
  imageBase64?: string;
  imageUrl?: string;
  imageName?: string;
  text: string | null;
  children?: React.ReactElement | null;
}

const RadioListItem: React.FC<RadioListItemProps> = props => {
  const { id, formik, value, name, imageUrl, imageName, imageBase64, text, children } = props;

  const radioRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    if (radioRef.current) {
      radioRef.current.click(); // Programmatically trigger the click event
    }
  };

  return (
    <li className="ui-widget-radio-list-item" onClick={handleClick}>
      <RadioButton
        id={id}
        formik={formik}
        value={value}
        name={name}
        ref={radioRef} // Attach the ref to the RadioButton
      />
      <Image imageUrl={imageUrl} classes={['ui-list-icon']} imageBase64={imageBase64} imageName={imageName} />
      {children || text}
    </li>
  );
};

export default RadioListItem;
